import './plugins'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import interceptors from './services/interceptors'
import i18n from './plugins/i18n'

interceptors.setupInterceptors();

Vue.config.productionTip = false

store.dispatch('initialiseStore').then(()=> {
  new Vue({
    i18n,
    store,
    router,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
})


